import { render, staticRenderFns } from "./100-ways-to-reduce-your-impact.vue?vue&type=template&id=71c61b5c&"
import script from "./100-ways-to-reduce-your-impact.vue?vue&type=script&lang=js&"
export * from "./100-ways-to-reduce-your-impact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports